<fr-dashboard>
  <zm-zip-history-table (copy)="onCopy($event)" (delete)="onDelete($event)" (detail)="onDetail($event)"
                        (download)="onDownload($event)"
                        (filterByName)="onFilterByName($event)"
                        (open)="onOpen($event)"
                        (rename)="onRename($event)"
                        (search)="onSearch($event)"
                        [items]="items$ | async"
                        [loading]="loading$ | async"></zm-zip-history-table>
</fr-dashboard>
